import React from 'react';
import '../css/Information.css';
import { IoArrowForward, IoPlay } from 'react-icons/io5';
import Image from 'react-image-webp';

import imageCard1 from '../images/imageCard1.jpg';
import imageCard1Webp from '../images/imageCard1.webp';

import imageCard2 from '../images/imageCard2.jpg';
import imageCard2Webp from '../images/imageCard2.webp';

import imageCard3 from '../images/imageCard3.jpg';
import imageCard3Webp from '../images/imageCard3.webp';

const information = [
	{
		id: 0,
		title: 'Campamento 3D',
		image: imageCard1,
		imageWebp: imageCard1Webp,
		url: 'https://libel.academy/3d-camp',
	},
	{
		id: 1,
		title: 'Membresía Recargada',
		image: imageCard2,
		imageWebp: imageCard2Webp,
		url: 'https://libel.academy/membresia',
	},
	{
		id: 2,
		title: 'Resultados de Alumnos',
		image: imageCard3,
		imageWebp: imageCard3Webp,
		url: 'https://libel.academy/resultados',
	},
];

const InformationCard = ({ title, image, imageWebp, url }) => {
	return (
		<div className='header-information-card'>
			<div className='information-card-play'>
				<Image
					webp={imageWebp}
					src={image}
					alt='Image Information'
					className='information-card-image'
				/>
				<span className='information-card-filter'>
					<IoPlay />
				</span>
			</div>
			<div className='information-card-content'>
				<h2>{title}</h2>
				<a className='information-card-more' href={url} target='_blank' rel='noreferrer'>
					Más información <IoArrowForward className='information-card-icon' />
				</a>
			</div>
		</div>
	);
};

const Information = () => {
	return (
		<section className='Information'>
			<div className='information-container container padding'>
				{information.map((item) => (
					<InformationCard
						key={item.id}
						title={item.title}
						image={item.image}
						imageWebp={item.imageWebp}
						url={item.url}
					/>
				))}
			</div>
		</section>
		// <div className="header-information container">
		//             {information.map(({ id, title, image, imageWebp, url }) => (
		//                 <InformationCard
		//                     key={id}
		//                     title={title}
		//                     image={image}
		//                     imageWebp={imageWebp}
		//                     url={url}
		//                 />
		//             ))}
		//         </div>
	);
};

export default Information;
